module.exports = __webpack_public_path__ + "img/emtpy.24ddd7d2.png";